/*
 * Public API Surface of sabis-editor2
 */

export * from './lib/sabis-texteditor2/text-editor.component';